module.exports = __webpack_public_path__ + "img/arrow copy.348dca5f.svg";